export enum CentreSubType {
  EvacuationCentreEntity = 'centres_evacuation-centre',
  EvacuationRespiteCentreEntity = 'centres_respite-centre',
}
